// Companies Tour
// Company records and linking contacts to the organizations they belong to
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_contacts); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const companiesTour = {
  id: 'companies',
  name: 'Companies Tour',
  displayName: 'Organize By Organization',
  description: 'Company records and linking contacts to the organizations they belong to',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_contacts',
      popover: {
        title: "🏢 Welcome to Companies",
        description: `
          If you sell to businesses, a **company** record is how you stop treating one account as several unrelated people.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📇 What a Company Holds",
        description: `
          The organisation's name, website, phone, address, and industry — plus every contact linked to it. Open the company and you see the whole relationship at once.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔗 Link Your Contacts",
        description: `
          Associate each person with their organisation. When someone new from a known company arrives, link them immediately so their history joins the account instead of starting a parallel one.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧠 Why It Changes Your Work",
        description: `
          You can see every conversation and deal across an account, spot who you have not spoken to, and recognise that a "new" lead is the third person from an existing customer.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧹 Keep Names Consistent",
        description: `
          "Acme", "Acme Inc", and "Acme Incorporated" become three companies and split the relationship. Pick one naming convention and merge duplicates when you find them.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Accounts, Not Just Contacts",
        description: `
          You can now:

✅ Create company records
✅ Link contacts to organisations
✅ See a whole account at a glance
✅ Keep naming clean

**Next:** create a company for your largest client and link everyone at it.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
